import styled, { css } from 'styled-components';

export const Subtitle = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const CurrentSO = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
`;

export const CurrentSOTitle = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
  `}
`;

export const CurrentSOTitleIcon = styled.img`
  width: 40px;
  height: 40px;
  display: block;
`;

export const CurrentSODescription = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    margin-top: 8px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const AddonsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 24px;
    border-radius: 16px;
    background-color: ${theme.v2.colors.neutral.highLight};
    width: 100%;
    gap: 24px;
    margin-top: 8px;
  `}    
`;

export const AddonsTitle = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const AddonsSubtitle = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowMedium};
  `}
`;

export const AddonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
`;

export const AddonsItem = styled.span`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark}; 
    
    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const AddonsItemIcon = styled.img`
  width: 40px;
  height: 40px;
  display: block;
`;
